import React from "react";
import UsersEmail from "./UsersEmail";

const ApplicantEmails=()=>{
  return <UsersEmail type="candidate" typeName="Candidates" />
}

export default ApplicantEmails;